// Applies a tenant's branding (tenant.branding, see TeacherBranding on the backend) to the page.
// Every field is optional: a missing value leaves the neutral platform default in place, it never
// falls back to another tenant's look or copy.

import { applyTheme } from "./Theme";

export function brandingOf(tenant) {
  return (tenant && tenant.branding) || {};
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function applyBranding(tenant, themeOverride) {
  const b = brandingOf(tenant);

  // Colours, fonts, layout and language come from the theme (see Theme.js); a theme preview from the teacher's
  // dashboard swaps in another theme file and choices for display only.
  if (themeOverride) {
    applyTheme(themeOverride.definition, themeOverride.choice);
  } else {
    applyTheme(b.themeDefinition, b);
  }

  if (b.tagline) setMeta("description", b.tagline);

  if (b.faviconUrl) {
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "icon");
      document.head.appendChild(link);
    }
    link.setAttribute("href", b.faviconUrl);
  }
}

/** Parsed "About" page content, or null when the tenant hasn't set any (the page then falls back to
 *  name/description, and the nav hides the link when there's nothing to show at all). */
export function aboutOf(tenant) {
  const raw = brandingOf(tenant).aboutJson;
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (e) {
    return null;
  }
}

export function hasAbout(tenant) {
  return !!(aboutOf(tenant) || (tenant && tenant.description));
}
